module.exports = __webpack_public_path__ + "static/media/Tick.5ddba2aa.svg";